module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "examples-page",
    class: _vm.$style.root
  }, [(_vm.loading) ? _c('loading') : _c('b-tabs', {
    ref: "tabs",
    staticClass: "top-tab-navigation",
    on: {
      "input": _vm.onTabChanged
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, _vm._l((_vm.tabs), function(tab, key) {
    return _c('b-tab', {
      key: key,
      attrs: {
        "title": _vm.$t(tab),
        "buttonId": "example-tab-" + key
      },
      on: {
        "click": _vm.triggerUpdate
      }
    }, [(key == 'examples') ? [_c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-12 col-lg-3"
    }, [_c('ul', {
      staticClass: "vertical-nav hidden-sm-down",
      attrs: {
        "role": "tablist"
      }
    }, _vm._l((_vm.examples), function(ex, index) {
      return _c('li', {
        key: index,
        class: ( _obj = {
          active: index === _vm.selected.examples
        }, _obj["example-" + index] = true, _obj ),
        attrs: {
          "data-toggle": "tab",
          "role": "tab"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            _vm.selected.examples = index
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('pos.examples.example.title', {
        slug: ex.slug
      })))])
      var _obj;
    })), (_vm.examples) ? _c('div', {
      staticClass: "select-container hidden-md-up"
    }, [_c('b-form-select', {
      staticClass: "form-control",
      attrs: {
        "options": _vm.examples
      },
      model: {
        value: (_vm.selected.examples),
        callback: function($$v) {
          _vm.selected.examples = $$v
        },
        expression: "selected.examples"
      }
    })], 1) : _vm._e()]), _c('div', {
      staticClass: "col-12 col-lg-9"
    }, [_c('div', {
      staticClass: "tab-content"
    }, _vm._l((_vm.examples), function(ex, index) {
      return _c('div', {
        staticClass: "tab-pane",
        class: {
          active: index === _vm.selected.examples
        },
        attrs: {
          "role": "tabpanel"
        }
      }, [_c('div', {
        staticClass: "format-swiper"
      }, [(index === _vm.selected.examples) ? _c('swiper', {
        ref: "examplesSwiper",
        refInFor: true,
        attrs: {
          "options": _vm.formatSwiperOptions
        }
      }, [_vm._l((_vm.getLocalizedImages(ex.images, ex.images_localized)), function(image, idx) {
        return _c('swiper-slide', {
          key: ("" + index + idx)
        }, [_c('img', {
          staticClass: "carousel-image",
          attrs: {
            "src": image
          }
        })])
      }), _c('div', {
        staticClass: "button button-desktop",
        attrs: {
          "slot": "button-prev"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.icons.getPostPreview("desktop"))
        },
        slot: "button-prev"
      }), _c('div', {
        staticClass: "button button-mobile",
        attrs: {
          "slot": "button-next"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.icons.getPostPreview("mobile"))
        },
        slot: "button-next"
      })], 2) : _vm._e()], 1)])
    }))])])])] : _vm._e(), (key == 'advantages') ? [_c('div', {
      staticClass: "container advantage-container"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col col-12 col-lg-3"
    }, [_c('ul', {
      staticClass: "vertical-nav hidden-md-down"
    }, _vm._l((_vm.advantages), function(adv, index) {
      return _c('li', {
        class: {
          "active": index === _vm.selected.advantages
        },
        on: {
          "click": function($event) {
            _vm.selected.advantages = index
          }
        }
      }, [_c('div', {
        staticClass: "advantages-title"
      }, [_vm._v(_vm._s(_vm.$t('pos.examples.advantage.title', {
        slug: adv.slug
      })))]), _c('markdown', {
        staticClass: "advantages-desc",
        attrs: {
          "source": _vm.$t('pos.examples.advantage.description', {
            slug: adv.slug,
            distanceUnit: _vm.distanceUnit
          })
        }
      })], 1)
    })), _c('swiper', {
      ref: "advantagesSwiper",
      refInFor: true,
      staticClass: "hidden-lg-up",
      attrs: {
        "options": _vm.swiperOption
      }
    }, _vm._l((_vm.advantages), function(adv, index) {
      return _c('swiper-slide', {
        key: index,
        class: {
          active: index === _vm.selected.advantages
        }
      }, [_c('div', {
        on: {
          "click": function($event) {
            _vm.selected.advantages = index
          }
        }
      }, [_c('div', {
        staticClass: "advantages-title"
      }, [_vm._v(_vm._s(_vm.$t('pos.examples.advantage.title', {
        slug: adv.slug
      })))]), _c('markdown', {
        staticClass: "advantages-desc",
        attrs: {
          "source": _vm.$t('pos.examples.advantage.description', {
            slug: adv.slug,
            distanceUnit: _vm.distanceUnit
          })
        }
      })], 1)])
    }))], 1), _c('div', {
      staticClass: "col col-12 col-lg-8 push-lg-1"
    }, _vm._l((_vm.advantages), function(adv, index) {
      return _c('img', {
        class: ["advantages-image", {
          "hidden-xl-down": index !== _vm.selected.advantages
        }],
        attrs: {
          "src": _vm.getLocalizedImages([adv.image], adv.images_localized, true),
          "alt": _vm.$t(("advantages.items." + (adv.slug) + ".title"))
        }
      })
    }))])])] : _vm._e(), (key == 'faq') ? [_c('div', {
      staticClass: "container faq-container"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col col-12 col-lg-8"
    }, [_c('ul', {
      staticClass: "vertical-nav"
    }, _vm._l((_vm.faq), function(faq, index) {
      return _c('li', {
        class: {
          "active": index === _vm.selected.faq
        },
        on: {
          "click": function($event) {
            _vm.selected.faq = index
          }
        }
      }, [_c('div', {
        staticClass: "faq-title"
      }, [_vm._v(_vm._s(_vm.$t('pos.examples.faq.title', {
        slug: faq.slug
      })))]), _c('div', {
        staticClass: "faq-desc"
      }, [_vm._v(_vm._s(_vm.$t('pos.examples.faq.description', {
        slug: faq.slug
      })))])])
    }))])])])] : _vm._e()], 2)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fad6011"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/examples/Examples.vue
// module id = 937
// module chunks = 1